const user_scopes = {
    descriptions: {
        custom_data: 'Dữ liệu tùy chỉnh của bạn',
        email: 'Địa chỉ email của bạn',
        phone: 'Số điện thoại của bạn',
        profile: 'Tên, tên người dùng, ảnh đại diện và thông tin hồ sơ khác của bạn',
        roles: 'Vai trò của bạn',
        identities: 'Các danh tính xã hội liên kết của bạn',
        'urn:logto:scope:organizations': 'Thông tin về tổ chức của bạn',
        'urn:logto:scope:organization_roles': 'Vai trò tổ chức của bạn',
        address: 'Địa chỉ của bạn',
    },
};
export default Object.freeze(user_scopes);
